import request from '@/utils/request'

export function getAppData() {
    return request({
        url: '/appmanager/data',
        method: 'post'
    })
}

export default{
    getAppData
} 